var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c(
        "div",
        { staticClass: "dashboard-block m-b-none" },
        [
          _c("div", { staticClass: "row-talent-response flex flex-col" }, [
            _c("div", { staticClass: "flex spacer-y-2" }, [
              _c("div", { staticClass: "w-1/2" }, [
                !_vm.showCommentBox
                  ? _c("h2", [_vm._v("Your Response")])
                  : _c("h2", [_vm._v("Why are you suitable?")]),
                _vm._v(" "),
                _c("div", { staticClass: "flex justify-start spacer-y-1" }, [
                  (_vm.talentResponseApplied || _vm.talentResponseDeclined) &&
                  !_vm.comment &&
                  _vm.booking.talent_can_comment
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-link",
                          on: {
                            click: () => {
                              this.showCommentBox = !this.showCommentBox
                              this.new_status = this.talent.response.status
                              this.new_comment = ""
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa",
                            class: this.showCommentBox ? "fa-minus" : "fa-plus",
                          }),
                          _vm._v(" Add comment\n          "),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col w-1/2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "btn-group btn-group-response flex justify-end align-center flex-wrap",
                  },
                  [
                    _vm.talentResponseApplied && _vm.showDateAppliedFor
                      ? _c(
                          "a",
                          {
                            key: "apply-active",
                            staticClass: "btn btn-accept active",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$declineModuleEnabled
                                    ? _vm.$t("Applied")
                                    : "Accepted"
                                ) +
                                " For"
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm._f("date")(
                                  _vm.talent.response.date_applied_for,
                                  _vm.$user.date_format_preference
                                )
                              ) + "\n          "
                            ),
                          ]
                        )
                      : _vm.talentResponseApplied
                      ? _c(
                          "a",
                          {
                            key: "apply-active",
                            staticClass: "btn btn-accept active",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$declineModuleEnabled
                                  ? _vm.$t("Applied")
                                  : "Accepted"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        !_vm.showCommentBox && !_vm.talentResponseApplied
                          ? _c(
                              "ladda-button",
                              {
                                staticClass: "btn btn-accept inactive",
                                attrs: {
                                  click: _vm.handleApplyOrSubmitClicked,
                                  disabled: _vm.talentCannotUpdateResponse,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.bookingIsStandardPackage ||
                                        !_vm.$declineModuleEnabled
                                        ? "Accept"
                                        : _vm.$t("Apply")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.talentResponseDeclined
                      ? _c(
                          "a",
                          {
                            key: "decline-active",
                            staticClass: "btn btn-decline active",
                          },
                          [_vm._v("Declined")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.talentCanDecline
                      ? _c(
                          "ladda-button",
                          {
                            key: "decline-inactive",
                            staticClass: "btn btn-decline inactive",
                            attrs: {
                              click: _vm.handleDeclineRequestCallback,
                              disabled: _vm.talentCannotUpdateResponse,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Decline")) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.talentResponseApplied &&
                    (_vm.booking.talent_can_comment || _vm.$commentModule) &&
                    _vm.clientName !== "GSE" &&
                    !_vm.bookingIsStandardPackage
                      ? _c(
                          "button",
                          {
                            key: "apply-comment-inactive",
                            staticClass: "btn btn-secondary inactive",
                            attrs: {
                              type: "button",
                              disabled: _vm.talentCannotUpdateResponse,
                              align: "right",
                            },
                            on: {
                              click: () => {
                                this.showCommentBox = !this.showCommentBox
                                this.new_status = "applied"
                                this.new_comment = ""
                              },
                            },
                          },
                          [
                            _c("img"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$declineModuleEnabled
                                    ? _vm.$t("Apply")
                                    : "Accept"
                                ) + " with Comment "
                              ),
                              !_vm.showCommentBox
                                ? _c("i", { staticClass: "fa fa-chevron-up" })
                                : _vm._e(),
                              _vm.showCommentBox
                                ? _c("i", { staticClass: "fa fa-chevron-down" })
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.showCommentBox
              ? _c(
                  "div",
                  { staticClass: "transition-text-area w-full spacer-b-2" },
                  [
                    _c(
                      "div",
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.new_comment.$model,
                              expression: "$v.new_comment.$model",
                            },
                          ],
                          ref: "comment_text_area",
                          staticClass:
                            "form-control comment-box response-text-area margin-b-2",
                          attrs: {
                            name: "comment",
                            rows: "2",
                            placeholder: _vm.$t(
                              "I would be great for this " +
                                _vm.$t("request") +
                                " because..."
                            ),
                          },
                          domProps: { value: _vm.$v.new_comment.$model },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.new_comment,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("vuelidate-help", {
                          staticClass: "error-colour margin-b-1",
                          attrs: {
                            field: _vm.$v.new_comment,
                            label: "Comment",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn-group flex justify-end -margin-t-1",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-sm btn-default margin-r-1",
                                on: {
                                  click: () => {
                                    this.showCommentBox = false
                                  },
                                },
                              },
                              [_vm._v("\n            Cancel\n          ")]
                            ),
                            _vm._v(" "),
                            _vm.new_comment && _vm.new_comment.length
                              ? _c(
                                  "ladda-button",
                                  {
                                    staticClass:
                                      "btn btn-success inactive btn-sm",
                                    attrs: {
                                      disabled: _vm.talentCannotUpdateResponse,
                                      click: _vm.handleCommentSubmitted,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.comment ? "Update" : "Submit"
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.comment &&
            _vm.comment.length &&
            _vm.booking.talent_can_comment &&
            !_vm.showCommentBox
              ? _c(
                  "div",
                  { staticClass: "w-full comment flex align-center" },
                  [
                    _c("div", { staticClass: "w-full spacer-r-3" }, [
                      _c("h3", [_vm._v("Your Comment")]),
                      _vm._v(" "),
                      _c("i", [_vm._v(_vm._s(_vm.talent.response.comment))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "commenter" }, [
                        _vm.$userIsClient
                          ? _c("span", [_vm._v("Updated ")])
                          : _c("span", [
                              _vm._v(
                                "Updated By " +
                                  _vm._s(
                                    _vm._f("sentenceCase")(
                                      _vm.responseUpdatedBy
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(" - " + _vm._s(_vm.responseUpdatedAt) + " "),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-default inactive flex-shrink-0 btn-sm margin-r-1",
                        on: {
                          click: () => {
                            this.showCommentBox = !this.showCommentBox
                            this.new_status = this.talent.response.status
                            this.new_comment = this.comment
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-pencil" }),
                        _vm._v(" Edit Comment\n      "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ladda-button",
                      {
                        key: "delete-comment",
                        staticClass:
                          "btn btn-danger inactive flex-shrink-0 btn-sm",
                        attrs: {
                          click: _vm.handleDeleteCommentCallback,
                          disabled: _vm.talentCannotUpdateResponse,
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash" }),
                        _vm._v(" Delete Comment\n      "),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("booking-talent-response-decline-modal", {
            ref: "modal",
            attrs: { booking: _vm.booking },
            on: {
              "comment-added": (comment) => {
                this.declineComment = comment
                this.decline_modal_submitted = true
              },
            },
            model: {
              value: _vm.declineRequestReason,
              callback: function ($$v) {
                _vm.declineRequestReason = $$v
              },
              expression: "declineRequestReason",
            },
          }),
          _vm._v(" "),
          _vm.booking.has_date_options_only
            ? _c("booking-talent-date-applied-for-modal", {
                attrs: {
                  dates: _vm.booking.date_options,
                  booking: _vm.booking,
                  talentId: _vm.$user.id,
                },
                model: {
                  value: _vm.dateAppliedFor,
                  callback: function ($$v) {
                    _vm.dateAppliedFor = $$v
                  },
                  expression: "dateAppliedFor",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }